import FirebaseModel from "@/Store/ORM/FirebaseORM/FirebaseModel";

export default class BillingPromotion extends FirebaseModel {
	static entity = 'billingPromotions';
	static baseCollection = this.firestore.collection('Configs').doc('Belit').collection('promotions');
	static fields(){
		return {
			name: this.attr(null),
			imperative_name: this.attr(null),
			min_price: this.number(0),
			min_test_count: this.number(null).nullable(),
			discount: this.number(0),
			allowed_categories: this.attr(null),
			has_tests: this.attr(null),
			allowed_tests: this.attr(null),
			...super.fields()
		}
	}
}
